import type { SVGProps } from "react"
import React from "react"

export const ArrowRightThin: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <title>Arrow Right Thin Icon</title>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 11.6115C3 11.7574 3.05795 11.8973 3.16109 12.0005C3.26424 12.1036 3.40413 12.1615 3.55 12.1615H19.26L13.26 18.1615C13.2088 18.2128 13.1682 18.2736 13.1404 18.3405C13.1127 18.4074 13.0985 18.4791 13.0985 18.5515C13.0985 18.624 13.1127 18.6957 13.1404 18.7626C13.1682 18.8295 13.2088 18.8903 13.26 18.9415C13.3112 18.9928 13.372 19.0334 13.4389 19.0611C13.5058 19.0888 13.5776 19.1031 13.65 19.1031C13.7224 19.1031 13.7942 19.0888 13.8611 19.0611C13.928 19.0334 13.9888 18.9928 14.04 18.9415L21.04 11.9415C21.1414 11.837 21.1981 11.6972 21.1981 11.5515C21.1981 11.4059 21.1414 11.266 21.04 11.1615L14.04 4.16154C13.9366 4.05811 13.7963 4 13.65 4C13.5037 4 13.3634 4.05811 13.26 4.16154C13.1566 4.26498 13.0985 4.40526 13.0985 4.55154C13.0985 4.69782 13.1566 4.83811 13.26 4.94154L19.43 11.1115H3.55C3.41174 11.1086 3.27761 11.1588 3.17528 11.2519C3.07295 11.3449 3.01021 11.4736 3 11.6115Z"
    />
  </svg>
)
